export default __webpack_public_path__ + "static/picto-5ca1815a92f77e2f24db7bb997602b3c.png";